<template>
  <div class="vendas-produtos">
    <box :title="t('Venda de produtos')">
      <div v-if="erro" class="vp-aviso-erro">{{ erro }}</div>

      <div v-else-if="!carregando && grupos.length === 0" class="vp-vazio">
        {{ t('Nenhuma venda de produto paga no período e nas franquias do filtro.') }}
      </div>

      <TabView v-else-if="grupos.length > 0" v-model="abaAtiva">
        <template #tablist>
          <div class="vp-abas" role="tablist" data-testid="vendas-produtos-paises">
            <Button v-for="(grupo, i) in grupos"
                    :key="grupo.pais"
                    size="small"
                    :severity="abaAtiva === i ? 'primary' : 'secondary'"
                    :outlined="abaAtiva !== i"
                    :data-testid="`tab-pais-${grupo.pais}`"
                    class="vp-aba"
                    @click="abaAtiva = i">
              {{ rotuloPais(grupo.pais) }}
            </Button>
          </div>
        </template>

        <!--
          Uma aba por país, cada uma com a própria tabela: o rodapé soma só
          dentro dela. Isso não é escolha de layout — é o que impede, pela
          estrutura, que reais, pesos e dólares caiam no mesmo total. O dinheiro
          operacional não guarda a moeda (chamado 2026-0049).
        -->
        <TabViewPanel v-for="(grupo, i) in grupos" :key="grupo.pais" :value="i">
          <p class="vp-nota">
            {{ t('Valores na moeda da franquia. Totais por país; a rede não soma moedas diferentes.') }}
            {{ t('O desconto mostrado foi dado na ORDEM e rateado entre os itens — o bruto é o preço de catálogo.') }}
          </p>

          <vendas-produtos-table :linhas="grupo.linhas" :pais="grupo.pais" />
        </TabViewPanel>
      </TabView>
    </box>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import { useVendasProdutos } from '../../composables/useVendasProdutos';
import TabView from '../../ui/TabView.vue';
import TabViewPanel from '../../ui/TabViewPanel.vue';

const { t } = useI18n();
const { grupos, carregando, erro, carregar } = useVendasProdutos();

const abaAtiva = ref<number>(0);

/** 'BR' → 'Brasil'; '??' fica explícito em vez de virar um país qualquer. */
function rotuloPais(pais: string): string {
  if (pais === '??') return t('País não identificado');
  return t(pais);
}

function recarrega(): void {
  abaAtiva.value = 0;
  void carregar();
}

onMounted(() => {
  log('VendasProdutosPage', 'mounted', 'Component mounted');
  void carregar();
  eventBus.on('filter.updated', recarrega);
});

onBeforeUnmount(() => {
  eventBus.off('filter.updated', recarrega);
});

defineExpose({ loadData: carregar });
</script>

<style scoped>
.vp-abas {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.vp-nota {
  margin: 0 0 0.75rem;
  font-size: 0.85rem;
  opacity: 0.75;
}

.vp-aviso-erro,
.vp-vazio {
  padding: 1rem;
}
</style>
